export interface GeekProfileAchievement {
  id: string;
  name: string;
  imagePath: string;
  description: string;
  date: string;
  reason: string;
}

export interface AchievementPerView {
  default: number;
  smResolution: number;
  mdResolution: number;
  lgResolution: number;
}

export const DEFAULT_ACHIEVEMENTS_PER_VIEW = 5;
export const DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW = 1;
export const DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW = 3;
export const DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW = 4;
